"use strict";
/**
 * validateDate function for validating the date format(MM/DD/YYYY)
 *
 * @param input - string
 * @returns string - whether the date format is valid or not
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateDate = void 0;
const validateDate = (input) => {
    const val = input.match(/^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/);
    let result = "";
    if (val) {
        result = val.join("").substring(0, 10);
    }
    if (result.length < 10) {
        return "Date should be in format MM/DD/YYYY";
    }
    return "";
};
exports.validateDate = validateDate;
